export default __webpack_public_path__ + "static/spa_eng-c97370447933bbaf0af01611b326b48e.svg";